import { render, staticRenderFns } from "./ConfirmationModalLayout.vue?vue&type=template&id=764ed0fe&scoped=true&"
import script from "./ConfirmationModalLayout.vue?vue&type=script&lang=js&"
export * from "./ConfirmationModalLayout.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationModalLayout.vue?vue&type=style&index=0&id=764ed0fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764ed0fe",
  null
  
)

export default component.exports